import axios from 'axios';

const api = axios.create({
  baseURL: 'https://garsconnect.in/api',
});

export default api;